import type React from 'react';
import { Page as Component } from '~/components/specifics/vendors/settings/company_settings/construction_item_settings/Page';

export const Page: React.FC = () => <Component />;
